import { render, staticRenderFns } from "./ModulesList.vue?vue&type=template&id=54d07aa5"
import script from "./ModulesList.vue?vue&type=script&lang=js"
export * from "./ModulesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports